import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Enhanced Navigation Script
document.addEventListener('DOMContentLoaded', function () {
	const mainNav = document.getElementById('main-nav');
	const mainLogo = document.getElementById('main-logo');

	// Mobile menu elements
	const mobileMenuButtonLayout = document.querySelector('.mobile-menu-button-layout');
	const mobileMenuLayout = document.getElementById('mobile-menu-layout');

	// Handle scroll events for all pages
	window.addEventListener('scroll', function () {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop > 50) {
			// Add white background and smaller logo when scrolled
			mainNav.classList.remove('bg-transparent');
			mainNav.classList.add(
				'bg-white/95',
				'backdrop-blur-md',
				'border-b',
				'border-[color:var(--agora-marble-dark)]',
				'shadow-sm',
			);

			// Shrink logo
			mainLogo.classList.remove('h-20');
			mainLogo.classList.add('h-12');

			// Update nav container height
			const navContainer = mainNav.querySelector('.flex.justify-between.items-center');
			navContainer.classList.remove('h-32', 'py-12');
			navContainer.classList.add('h-16');

			// Update nav link colors
			const navLinks = mainNav.querySelectorAll('.agora-nav-link');
			navLinks.forEach((link) => {
				link.classList.remove('text-[color:var(--agora-shadow-dark)]');
				link.classList.add('text-[color:var(--agora-stone)]');
				link.style.textShadow = '';
			});

			// Update mobile menu button color
			const mobileButton = mainNav.querySelector('.mobile-menu-button-layout');
			if (mobileButton) {
				mobileButton.classList.remove('text-[color:var(--agora-shadow-dark)]');
				mobileButton.classList.add('text-[color:var(--agora-stone)]');
			}

			// Update mobile menu background
			const mobileMenu = mainNav.querySelector('#mobile-menu-layout > div');
			if (mobileMenu) {
				mobileMenu.classList.remove('bg-white/90', 'backdrop-blur-sm');
				mobileMenu.classList.add('bg-white');
			}
		} else {
			// Remove white background and restore larger logo at top
			mainNav.classList.add('bg-transparent');
			mainNav.classList.remove(
				'bg-white/95',
				'backdrop-blur-md',
				'border-b',
				'border-[color:var(--agora-marble-dark)]',
				'shadow-sm',
			);

			// Restore larger logo
			mainLogo.classList.add('h-20');
			mainLogo.classList.remove('h-12');

			// Update nav container height
			const navContainer = mainNav.querySelector('.flex.justify-between.items-center');
			navContainer.classList.add('h-32', 'py-12');
			navContainer.classList.remove('h-16');

			// Restore nav link colors
			const navLinks = mainNav.querySelectorAll('.agora-nav-link');
			navLinks.forEach((link) => {
				link.classList.add('text-[color:var(--agora-shadow-dark)]');
				link.classList.remove('text-[color:var(--agora-stone)]');
				link.style.textShadow = '0 1px 2px rgba(255, 255, 255, 0.8)';
			});

			// Restore mobile menu button color
			const mobileButton = mainNav.querySelector('.mobile-menu-button-layout');
			if (mobileButton) {
				mobileButton.classList.add('text-[color:var(--agora-shadow-dark)]');
				mobileButton.classList.remove('text-[color:var(--agora-stone)]');
			}

			// Update mobile menu background
			const mobileMenu = mainNav.querySelector('#mobile-menu-layout > div');
			if (mobileMenu) {
				mobileMenu.classList.add('bg-white/90', 'backdrop-blur-sm');
				mobileMenu.classList.remove('bg-white');
			}
		}
	});

	// Mobile menu toggle for layout navigation
	if (mobileMenuButtonLayout && mobileMenuLayout) {
		const hamburgerIcon = mobileMenuButtonLayout.querySelector('.hamburger-icon');
		const closeIcon = mobileMenuButtonLayout.querySelector('.close-icon');
		const backdrop = mobileMenuLayout.querySelector('.mobile-menu-backdrop');
		const content = mobileMenuLayout.querySelector('.mobile-menu-content');
		const closeButton = mobileMenuLayout.querySelector('.mobile-menu-close');

		function openMobileMenu() {
			// Show the overlay
			mobileMenuLayout.classList.remove('hidden');

			// Prevent body scroll
			document.body.style.overflow = 'hidden';

			// Toggle icons
			hamburgerIcon.classList.add('hidden');
			closeIcon.classList.remove('hidden');

			// Animate backdrop
			setTimeout(() => {
				backdrop.classList.remove('opacity-0');
				backdrop.classList.add('opacity-100');
			}, 10);

			// Animate content
			setTimeout(() => {
				content.classList.remove('scale-95', 'opacity-0');
				content.classList.add('scale-100', 'opacity-100');
			}, 50);
		}

		function closeMobileMenu() {
			// Animate content out
			content.classList.remove('scale-100', 'opacity-100');
			content.classList.add('scale-95', 'opacity-0');

			// Animate backdrop out
			backdrop.classList.remove('opacity-100');
			backdrop.classList.add('opacity-0');

			// Toggle icons
			hamburgerIcon.classList.remove('hidden');
			closeIcon.classList.add('hidden');

			// Hide the overlay after animation
			setTimeout(() => {
				mobileMenuLayout.classList.add('hidden');
				document.body.style.overflow = '';
			}, 300);
		}

		// Open menu when hamburger button is clicked
		mobileMenuButtonLayout.addEventListener('click', function (e) {
			e.preventDefault();
			if (mobileMenuLayout.classList.contains('hidden')) {
				openMobileMenu();
			} else {
				closeMobileMenu();
			}
		});

		// Close menu when close button is clicked
		if (closeButton) {
			closeButton.addEventListener('click', function (e) {
				e.preventDefault();
				closeMobileMenu();
			});
		}

		// Close menu when backdrop is clicked
		if (backdrop) {
			backdrop.addEventListener('click', function (e) {
				e.preventDefault();
				closeMobileMenu();
			});
		}

		// Close menu when navigation link is clicked
		const navLinks = mobileMenuLayout.querySelectorAll('.agora-nav-link');
		navLinks.forEach((link) => {
			link.addEventListener('click', function () {
				closeMobileMenu();
			});
		});

		// Close menu on escape key
		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape' && !mobileMenuLayout.classList.contains('hidden')) {
				closeMobileMenu();
			}
		});
	}
});

// Column Background Script
document.addEventListener('DOMContentLoaded', function () {
	// Wait a bit for the page to fully render
	setTimeout(function () {
		// Column images with their designated positions
		const columnData = [
			{
				image: 'columns-a.svg',
				positions: ['top right'],
			},
			{
				image: 'columns-b.svg',
				positions: ['top left'],
			},
			{
				image: 'columns-c.svg',
				positions: ['top right'],
			},
			{
				image: 'columns-d.svg',
				positions: ['bottom right'],
			},
			{
				image: 'columns-e.svg',
				positions: ['top left'],
			},
			{
				image: 'columns-f.svg',
				positions: ['bottom left'],
			},
			{
				image: 'columns-g.svg',
				positions: ['bottom right', 'bottom left'],
			},
		];

		// Find all sections that can have backgrounds
		const sections = document.querySelectorAll('section');

		// Filter to get valid sections
		const validSections = Array.from(sections).filter((section) => {
			const hasNav = section.querySelector('nav');
			const isFooter = section.closest('footer');
			const hasMinHeight = section.offsetHeight > 200;

			return !hasNav && !isFooter && hasMinHeight;
		});

		if (validSections.length === 0) return;

		// Apply backgrounds to ALL sections using the same approach
		validSections.forEach((section, index) => {
			// Ensure section has relative positioning
			section.style.position = 'relative';

			// Randomly select a column
			const randomColumn = columnData[Math.floor(Math.random() * columnData.length)];

			// Randomly select a position for this column
			const randomPosition =
				randomColumn.positions[Math.floor(Math.random() * randomColumn.positions.length)];

			// Create decorative div
			const decorativeDiv = document.createElement('div');
			decorativeDiv.style.cssText = `
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-image: url('/images/${randomColumn.image}');
                background-repeat: no-repeat;
                background-position: ${randomPosition};
                background-size: contain;
                opacity: 0.08;
                pointer-events: none;
                z-index: 0;
                transition: opacity 0.3s ease;
            `;
			decorativeDiv.className = 'column-background-decoration';

			// Insert at the beginning of the section so it's behind everything
			section.insertBefore(decorativeDiv, section.firstChild);

			// Add hover effect
			section.addEventListener('mouseenter', () => {
				decorativeDiv.style.opacity = '0.12';
			});
			section.addEventListener('mouseleave', () => {
				decorativeDiv.style.opacity = '0.08';
			});
		});
	}, 100);
});
